import $ from 'jquery'
import { GeoJSON } from 'ol/format'
import SearchResultDropdown from './ui/SearchResultDropdown'
import Spinner from './ui/Spinner'
import Feature from 'ol/Feature'
import { extend } from 'ol/extent'

/**
 * @param {Object} config
 * @constructor
 */
export default function AutoSearch(config) {
  $.extend(this, config || {})

  this.ui = new SearchResultDropdown({
    autoSearch: this,
    displayField: this.displayField
  })

  const srsname =
    this.map
      .getView()
      .getProjection()
      .getCode() || 'EPSG:3006'
  var normalizeCQL = !this.cqlFilter ? this.cql_Filter : this.cqlFilter
  var accessToken = !this.access_token ? this.accessToken : this.access_token
  var url =
    (this.baseUrl || 'https://olgatest.scaskog.com/ows/wfs') +
    '?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&TYPENAME=' +
    this.typeName +
    '&OUTPUTFORMAT=application/json&SRSNAME=' +
    srsname +
    (normalizeCQL ? '&CQL_FILTER=' + normalizeCQL : '') +
    (this.viewparams ? '&VIEWPARAMS=' + this.viewparams : '') +
    (accessToken ? '&access_token=' + accessToken : '')

  this.spinner = new Spinner()
  this.spinner.start()
  $.ajax({
    url: url,
    success: this.processResult.bind(this)
  })
}

/**
 * Clean up resources
 */
AutoSearch.prototype.dispose = function() {
  // goog.dispose(this.ui)
}

/**
 * Process results from WFS
 * @param {Object} e
 */
AutoSearch.prototype.processResult = function(e) {
  var format = new GeoJSON()
  var features = format.readFeatures(e)
  if (features.length > 0) {
    if (this.viewAllOption) {
      this.zoomToMany(features)
      this.ui.setFeatures(features)
    } else {
      this.zoomTo(features[0])
      this.ui.setFeatures(features)
    }
  }
  this.spinner.stop()
}

/**
 * Zoom to feature
 * @param {Feature} feature
 */
AutoSearch.prototype.zoomTo = function(feature) {
  var extent = feature.get('geometry').getExtent()
  this.map.getView().fit(extent, this.map.getSize())
}

/**
 * Zoom to many features
 *  @param {Array.<Feature>} features
 */

AutoSearch.prototype.zoomToMany = function(features) {
  let extent = features
    .map(f => f.get('geometry').getExtent())
    .reduce((prevExtent, currExtent) => extend(prevExtent, currExtent))
  if (!extent.some(coord => coord === Infinity)) {
    this.map.getView().fit(extent, { padding: [25, 25, 25, 25] })
  }
}
